import { useEffect, useState } from "react";
import api from "@/lib/api";
import { GlobalPictogramCategories } from "@/components/GlobalPictogramCategories";
import { GlobalPictogramLibrary } from "@/components/GlobalPictogramLibrary";

export default function SuperAdminPictograms() {
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [migration, setMigration] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const reload = async () => {
    try {
      const [cats, pictos, status] = await Promise.all([
        api.get("/admin/pictogram-categories"), api.get("/admin/pictograms"),
        api.get("/admin/pictograms/migration-status").catch(() => ({ data: null }))
      ]);
      setCategories(cats.data); setItems(pictos.data); setMigration(status.data); setError("");
    } catch { setError("Impossibile caricare i pittogrammi. Riprova."); }
    finally { setLoading(false); }
  };
  useEffect(() => { reload(); }, []);
  return <div className="p-4 md:p-8 lg:p-12 max-w-[1440px] mx-auto" data-testid="superadmin-pictograms-page">
    <div className="mb-12 border-b border-[#D4D4D4] pb-8">
      <div className="text-[10px] text-[#707070] uppercase tracking-luxury mb-2">Libreria condivisa</div>
      <h1 className="font-serif text-4xl md:text-5xl">Pittogrammi</h1>
      <p className="text-sm text-[#525252] mt-3">Categorie e simboli di default disponibili per tutti gli abbonamenti.</p>
      {migration?.status === "complete" && migration.source_pictograms > 0 &&
        <p className="text-xs text-[#525252] mt-3" data-testid="admin-pictograms-migration-summary">
          {migration.shared_pictograms} pittogrammi originali importati da {migration.source_pictograms} voci · {migration.shared_categories} categorie
        </p>}
      {migration && migration.status !== "complete" && <p role="alert" className="text-xs text-[#B91C1C] mt-3"
        data-testid="admin-pictograms-migration-incomplete">Importazione degli originali non completata.</p>}
    </div>
    {loading && <p className="text-sm text-[#707070]" data-testid="admin-pictograms-loading">Caricamento...</p>}
    {error && <div role="alert" className="text-sm text-[#B91C1C] mb-6" data-testid="admin-pictograms-error">
      {error} <button type="button" onClick={reload} className="underline" data-testid="admin-pictograms-retry">Riprova</button>
    </div>}
    {!loading && !error && <>
      <GlobalPictogramCategories categories={categories} reload={reload} />
      <GlobalPictogramLibrary categories={categories} items={items} reload={reload} />
    </>}
  </div>;
}